/* eslint max-len: "off" */
import { Tracker } from '@reverbdotcom/discovery-ui';
import * as elog from '@reverbdotcom/elog';
import * as Raven from 'raven-js';
import { parseMeta } from './parse_meta';

const ELOG_CONFIG_KEY = 'elog-config';
const CURRENT_USER_KEY = 'current-user';

function isBot() {
  const userConfig = parseMeta(CURRENT_USER_KEY);

  return userConfig &&
    userConfig.user &&
    userConfig.user.isBot;
}

function initializeElog() {
  const elogConfig = parseMeta(ELOG_CONFIG_KEY);

  if (elogConfig) {
    const config = Object.assign(
      {},
      elogConfig.elog,
      { ravenClient: Raven },
    );

    elog.configure(config);
    elog.identify(config.userContext);
    Tracker.pageView();
  }
}

function init() {
  initializeElog();
}

init();

export default {
  init, // for testing only
};



// WEBPACK FOOTER //
// ./javascripts/components/error_logger.js